import { Input, Select } from '@iwoca/orion';
import { FieldErrorsImpl, UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import {
    titleMessages,
    titles
} from '../../../../../../../forms/nameField/Titles';
import { TFormValues } from '../../../../../../funding/fundingSteps/majorShareholderCheckAction/mshModal/MSHForm.types';

type TNameFieldsProps = {
    errors: FieldErrorsImpl<TFormValues>;
    register: UseFormRegister<TFormValues>;
    disabled: boolean;
};

export const NameFields = ({
    errors,
    register,
    disabled
}: TNameFieldsProps) => {
    const intl = useIntl();

    return (
        <div className="flex flex-col gap-l">
            <Select
                {...register('title')}
                label={intl.formatMessage({
                    id: '_.shareholder_form.title_field_label',
                    defaultMessage: 'Title'
                })}
                placeholder={intl.formatMessage({
                    id: '_.shareholder_form.title_field_placeholder',
                    defaultMessage: 'Title'
                })}
                disabled={disabled}
                error={
                    errors.title &&
                    intl.formatMessage({
                        id: '_.shareholder_form.error.valid_title_required',
                        defaultMessage: 'Please enter a valid title'
                    })
                }
            >
                {titles.map(({ value, messageKey }, index) => (
                    <option key={index + value} value={value}>
                        {intl.formatMessage(titleMessages[messageKey])}
                    </option>
                ))}
            </Select>

            <Input
                {...register('firstName', { required: true })}
                type="text"
                label={intl.formatMessage({
                    id: '_.shareholder_form.first_name_label',
                    defaultMessage: 'First name'
                })}
                placeholder={intl.formatMessage({
                    id: '_.shareholder_form.first_name_field_placeholder',
                    defaultMessage: 'First name'
                })}
                disabled={disabled}
                error={
                    errors.firstName &&
                    intl.formatMessage({
                        id: '_.shareholder_form.error.valid_first_name_required',
                        defaultMessage: 'Please enter a valid first name'
                    })
                }
            />

            <Input
                {...register('lastName', { required: true })}
                type="text"
                label={intl.formatMessage({
                    id: '_.shareholder_form.last_name_label',
                    defaultMessage: 'Last name'
                })}
                placeholder={intl.formatMessage({
                    id: '_.shareholder_form.last_name_field_placeholder',
                    defaultMessage: 'Last name'
                })}
                disabled={disabled}
                error={
                    errors.lastName &&
                    intl.formatMessage({
                        id: '_.shareholder_form.error.valid_last_name_required',
                        defaultMessage: 'Please enter a valid last name'
                    })
                }
            />
        </div>
    );
};
